import React from 'react';
import buildContext from '~/components/jsx-helpers/build-context';
function useContextValue() {
    const [portal, setPortal] = React.useState('');
    // Start with true (GTM disabled) until we determine it's safe to enable
    const [isK12Portal, setIsK12Portal] = React.useState(true);
    const portalPrefix = portal ? `/${portal}` : '';
    const rewriteLinks = React.useCallback((container) => {
        if (!portalPrefix) {
            return;
        }
        const linkNodes = container.querySelectorAll('a[href^="/"]');
        for (const node of linkNodes) {
            const href = node.getAttribute('href');
            node.setAttribute('href', `${portalPrefix}${href}`);
        }
    }, [portalPrefix]);
    return { portalPrefix, setPortal, rewriteLinks, isK12Portal, setIsK12Portal };
}
const { useContext, ContextProvider } = buildContext({ useContextValue });
export { useContext as default, ContextProvider as PortalContextProvider };
